import { render } from "./dialog.vue?vue&type=template&id=1b01da9b&ts=true"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__